import React from 'react';
import TranslateText from '../../translation/TranslateText'; // Adjust the import path as needed
import './Boost.css'; // Import CSS file for styling

function Tips() {
  return (
    <div>
      <div className='pad boost-container centered-text'>
        <span className='large-text4'>
          <TranslateText text="TIPS FOR SELECTING TRADELINES" />
        </span>
        <div className="separator2"></div>
        <br />
        <span className='large-text'>
          <TranslateText text="The amount by which a credit score can increase is different for everyone." />
        </span>
        <br />
        <span className='large-text'>
          <TranslateText text="We stick to a few rules of thumb when determining the benefits that you will receive:" />
        </span>
        <br />
        <span className='large-text'>
          <TranslateText text="Higher limits and older aged tradelines correlate to bigger credit score increases." />
        </span>
        <span className='large-text'>
          <TranslateText text="Older accounts make your file more solid." />
        </span>
        <span className='large-text'>
          <TranslateText text="3. If you have nothing on your credit file, you must select something at least 6 months old to generate a credit score and avoid a thin file error." />
        </span>
        <span className="large-text">
          <TranslateText text="4. The fewer addresses you have on your credit report, the better." />
        </span>
        <span className="large-text">
          <TranslateText text="We can filter the list by address code to help you select lines from the same cardholder or we can help you with this one-on-one." />
        </span>
        <span className="large-text">
          <TranslateText text="Please contact Ariella or Adiyah directly if you want to do this." />
        </span>
        <span className="large-text">
          <TranslateText text="5. All of our tradelines are under 30% unless otherwise noted in the comment section. All tradelines have a perfect payment history." />
        </span>
        <span className="large-text">
          <TranslateText text="6. If you have negative items on your credit report, this can offset the boost that you could get." />
        </span>
        <span className="large-text">
          <TranslateText text="You may need to have a credit sweep, which we provide, in order to get the maximum boost possible from tradeline(s)." />
        </span>
        <span className="large-text">
          <TranslateText text="Tradelines are not a band-aid, they are an enhancement." />
        </span>
      </div>
    </div>
  )
}

export default Tips;



// import React from 'react'

// function Tips() {
//     return (
//         <div>
//             <div className='pad boost-container centered-text'>
//             <span className='large-text4'>TIPS FOR SELECTING TRADELINES  </span>
//             <div className="separator2"></div>
//             <br></br>
//             <span className='large-text'>The amount by which a credit score can increase is different for everyone.</span>
//             <br></br>
//             <span className='large-text'>We stick to a few rules of thumb when determining the benefits that you will receive:</span>
//             <br></br>
//             <span className='large-text'>Higher limits and older aged tradelines correlate to bigger credit score increases.</span>
//             <span className='large-text'>Older accounts make your file more solid.</span>
//             <span className='large-text'>3. If you have nothing on your credit file, you must select something at least 6 months old to generate a credit score and avoid a thin file error.</span>
//             <span className="large-text">4. The fewer addresses you have on your credit report, the better.</span>
//             <span className="large-text">We can filter the list by address code to help you select lines from the same cardholder or we can help you with this one-on-one.</span>
//             <span className="large-text">Please contact Ariella or Adiyah directly if you want to do this.</span>
//             <span className="large-text">5. All of our tradelines are under 30% unless otherwise noted in the comment section. All tradelines have a perfect payment history.</span>
//             <span className="large-text">6. If you have negative items on your credit report, this can offset the boost that you could get.</span>
//             <span className="large-text">You may need to have a credit sweep, which we provide, in order to get the maximum boost possible from tradeline(s).</span>
//             <span className="large-text">Tradelines are not a band-aid, they are an enhancement.</span>
    
    
    
//              </div>
//         </div>
//       )
// }

// export default Tips
